import { useState, useContext } from "react";
import { ThemeCtx, hasAccess } from "./AppShell";
import ClinicalTimeline from "./ClinicalTimeline";
import EventsTimeline from "./EventsTimeline";
import ProductProfileScreen from "./Product_profile";

const ALL_TABS = [
  { id:"clinical",  label:"Clinical Trials",  icon:"🧪", key:"CLINICAL_TRIALS" },
  { id:"upcoming",  label:"Upcoming Events",  icon:"📅", key:"UPCOMING_EVENTS" },
  { id:"past",      label:"Past Events",      icon:"⏪", key:"UPCOMING_EVENTS" },
  { id:"products",  label:"Product Profiles", icon:"💊", key:"PRODUCT"         },
];

function TabBar({ tabs, active, onChange, theme }) {
  const primary = theme?.primary || "#6366F1";
  return (
    <div style={{ display:"flex", borderBottom:"none",
      background:"#fff", paddingLeft:"16px", flexShrink:0,
      overflowX:"auto", scrollbarWidth:"none" }}>
      {tabs.map(tab => {
        const on = active === tab.id;
        return (
          <button key={tab.id} onClick={() => onChange(tab.id)} style={{
            display:"flex", alignItems:"center", gap:"7px",
            padding:"8px 16px", border:"none", background:"transparent",
            cursor:"pointer", whiteSpace:"nowrap", flexShrink:0,
            fontSize:"13px", fontWeight: on ? "700" : "500",
            color: on ? primary : "#6B7280",
            borderBottom: on ? `3px solid ${primary}` : "3px solid transparent",
            marginBottom:"-2px", transition:"all 0.15s",
          }}>
            <span style={{ fontSize:"15px" }}>{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default function TimelinesScreen({ user, subproject }) {
  const ctx   = useContext(ThemeCtx) || {};
  const theme = ctx.theme || ctx || {};

  const tabs    = ALL_TABS.filter(t => hasAccess(subproject, t.key));
  const [activeTab, setActiveTab] = useState(() => tabs[0]?.id || "");
  const safeTab = tabs.find(t => t.id === activeTab)?.id || tabs[0]?.id || "";

  if (!tabs.length) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center",
      height:"100%", flexDirection:"column", color:"#9CA3AF", gap:"12px" }}>
      <div style={{ fontSize:"48px", opacity:0.2 }}>📊</div>
      <div style={{ fontSize:"15px" }}>No timeline access for this subproject</div>
    </div>
  );

  const renderTab = () => {
    switch (safeTab) {
      case "clinical":
        return <ClinicalTimeline user={user} subproject={subproject} />;
      case "upcoming":
        return <EventsTimeline key="upcoming" user={user} subproject={subproject} initialType="upcoming" hideToggle={true} />;
      case "past":
        return <EventsTimeline key="past" user={user} subproject={subproject} initialType="past" hideToggle={true} />;
      case "products":
        return <ProductProfileScreen user={user} subproject={subproject} defaultView="chart" hideToggle={true} />;
      default:
        return null;
    }
  };

  return (
    <div style={{ display:"flex", flexDirection:"column", height:"100%", overflow:"hidden" }}>

      {/* Compact tab bar only — no title, no padding waste */}
      <div style={{ flexShrink:0, background:"#fff", borderBottom:"1px solid #E5E7EB" }}>
        <TabBar tabs={tabs} active={safeTab} onChange={setActiveTab} theme={theme} />
      </div>

      {/* Chart — takes all remaining height */}
      <div style={{ flex:1, overflow:"hidden", background:"#F8FAFC" }}>
        {renderTab()}
      </div>
    </div>
  );
}